import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { motion } from "framer-motion";

interface ClutchData {
  overall_rating: number;
  review_count: number;
}

const ClutchBadge = () => {
  const [data, setData] = useState<ClutchData | null>(null);

  useEffect(() => {
    const fetch = async () => {
      const { data: rows } = await supabase
        .from("clutch_data")
        .select("overall_rating, review_count")
        .limit(1);
      if (rows && rows.length > 0) setData(rows[0]);
    };
    fetch();
  }, []);

  if (!data || data.review_count === 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: 1.0, duration: 0.5 }}
      className="flex items-center justify-center gap-2 mt-3"
    >
      <div className="flex items-center gap-0.5">
        {Array.from({ length: 5 }).map((_, i) => (
          <Star
            key={i}
            className="w-3.5 h-3.5 fill-rating text-rating"
          />
        ))}
      </div>
      <span className="text-sm text-muted-foreground">
        {data.overall_rating.toFixed(1)} from {data.review_count} verified reviews
      </span>
      <a
        href="https://clutch.co/profile/techneed"
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs text-primary hover:underline font-medium"
      >
        Clutch
      </a>
    </motion.div>
  );
};

export default ClutchBadge;
